<template>
  <div>
    <div v-for="(content, index) in contents" :key="index" class="contents">
      <h3>{{ content.header }}</h3>
      <br />
    </div>
  </div>
</template>

<script>
export default {
  name: 'IntroContents',
  data() {
    return {
      contents: [
        {
          header: 'SECTION',
          paragrapth: '',
        },
        {
          header: this.$i18n.locale === 'eng' ? 'About our services' : '서비스 소개',
          paragrapth: '',
        },
        {
          header: this.$i18n.locale === 'eng' ? 'Participating researchers' : '참여 연구진',
          paragrapth: '',
        },
      ],
    };
  },
  watch: {
    '$i18n.locale': function (newLocale, oldLocale) {
      this.contents[1].header = newLocale === 'eng' ? 'About our services' : '서비스 소개';
      this.contents[2].header = newLocale === 'eng' ? 'Participating researchers' : '참여 연구진';
    },
  },
};
</script>

<style lang="scss"></style>
